


























































































/** @format */

import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import { cloneDeep } from 'lodash';
import { trim } from '@/utils/validators';
import Utils from '@/utils/common';
import moemnt from 'moment';
// axios请求
import { addOrEditSentry, editInfoSentry } from '@/api/parking-lot-management/index';
// 导入字典
import {
  dictOperationTypeMap,
  dictTypeInMap,
  dictAllowableChannelTypeMap,
  dictAlonePayMap,
  dictfeiPayMap
} from '@/types/parking-lot-management/dictionaries';
import moment from 'moment';

// form表单项定义
export interface IForm {
  id: number;
  startTime: any;
  endTime: any;
  oneTime: any;
  money: any;
  highMoney: any;
  rule: any;
}

@Component({
  //   components: { ParkingLotSearch },
})
export default class AddByTime extends Vue {
  @Prop()
  newFlerRules!: any;

  //   @Prop()
  //   parkId!: string

  @Prop()
  isTableNum!: string;

  //   @Prop({ type: Boolean, default: false })
  //   isEdit!: boolean

  @Prop({ type: Boolean, default: false })
  isvisible!: boolean;

  id = '';
  enabled = true;
  // 表单
  form: any = null;
  validatorsTrim = trim;
  spinning: boolean = false;

  @Watch('newFlerRules', { deep: true })
  newFlerRulesChanged(val: any) {
    // this.init()
    // this.enabled = val.enabled
    if (val.length > 0) {
      // this.form.setFieldsValue('startTime', val[val.length - 1].endTime + 1)
      //   this.startTime = val[val.length - 1].startTime
    } else {
      // this.form.setFieldsValue('startTime', 1)
    }
  }
  startTimeSet = 0;
  @Watch('isvisible', { deep: true })
  isvisibleChange(val: any) {
    // this.init()
    // this.enabled = val.enabled
    console.log(this.newFlerRules, '000---111---22---333-----------');
    if (val) {
      // this.$nextTick(() => {
      //   this.form.setFieldsValue('startTime', this.newFlerRules[this.newFlerRules.length - 1].endTime)
      // console.log(val, this.newFlerRules[this.newFlerRules.length - 1].endTime + 1, '--------00000------------->>>>>')
      if (this.newFlerRules && this.newFlerRules.length < 1) {
        this.startTimeSet = 0;
      } else {
        this.startTimeSet = this.newFlerRules[this.newFlerRules.length - 1].endTime;
      }
      // })
      //   this.startTime = val[val.length - 1].startTime
    } else {
      this.startTimeSet = 0;
      // this.form.setFieldsValue('startTime', 1)
    }
  }

  //   // 是否是禁用
  //   get isParkdisabledFlag() {
  //     return this.isParkDisabled
  //   }

  // 生命周期初始化
  created() {
    // if (this.isEdit) {
    //   this.enabled = this.dataForm.enabled === '01'
    // }
    // this.id = this.$route.params.id
    this.init();
    // let av = '00:00'
    // let bv = '20:00'
    // let u1 = `2020-10-10 ${av}:00`
    // let u2 = `2020-10-10 ${av}:00`
    // console.log(av, bv, u1, u2, '0000------------------>')
    // console.log(`2020-10-10 ${av}:00`)
  }

  // 初始化form表单
  init() {
    // if (this.isEdit && this.dataForm) {
    //   this.form = this.$form.createForm(this, {
    //     mapPropsToFields: () => {
    //       const { startTime, endTime, oneTime, money, highMoney, rule } = this.dataForm
    //       return {
    //         startTime: this.$form.createFormField({
    //           value: startTime,
    //         }),
    //         endTime: this.$form.createFormField({
    //           value: endTime,
    //         }),
    //         oneTime: this.$form.createFormField({
    //           value: oneTime,
    //         }),
    //         money: this.$form.createFormField({
    //           value: money,
    //         }),
    //         highMoney: this.$form.createFormField({
    //           value: highMoney,
    //         }),
    //         rule: this.$form.createFormField({
    //           value: rule,
    //         }),
    //       }
    //     },
    //   })
    // } else {
    this.form = this.$form.createForm(this);
    // }
  }

  // 关闭模态框
  handleCancel() {
    this.$emit('closeModeVisible');
    this.form.resetFields();
  }
  moment = moment;
  // 提交监听处理
  async handleSubmit(e: any) {
    // console.log(e)
    e.stopPropagation();
    e.preventDefault();
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        // console.log(this.newFlerRules.length, '我来了---------》111')
        this.getRulesChange(values);
      }
    });
  }

  //   校验规则
  getRulesChange(values) {
    if (this.newFlerRules && this.newFlerRules.length === 0) {
      // 之前没有数据
      console.log('shi 000');
      if (values.startTime > values.endTime) {
        return this.$message.warning('结束时间需要大于等于起始时间');
      }
      if (values.startTime === values.endTime) {
        return this.$message.warning('结束时间需要大于等于起始时间');
      }
      if (values.startTime === 0) {
        let a = values.endTime - values.startTime;
        let b = a % values.oneTime;
        if (b === 0) {
          console.log('111');
          values.id = new Date().getTime();
          console.log(values, '拿到了');
          this.$emit('submitOK', values, this.isTableNum);
          this.form.resetFields();
        } else {
          return this.$message.warning('结束时间与起始时间差必须是单位时长的整数倍');
        }
      } else {
        return this.$message.warning('起始时间需要从0开始');
      }
    } else {
      console.log('bushi 000000------');
      if (values.startTime > values.endTime) {
        return this.$message.warning('结束时间需要大于等于起始时间');
      }
      if (values.startTime === values.endTime) {
        return this.$message.warning('结束时间需要大于等于起始时间');
      }
      //   之前有数据
      let end = this.newFlerRules[this.newFlerRules.length - 1].endTime;
      if (values.startTime === end) {
        let a = values.endTime - values.startTime;
        let b = a % values.oneTime;
        if (b === 0) {
          console.log('111');
          values.id = new Date().getTime();
          console.log(values, '拿到了');
          this.$emit('submitOK', values, this.isTableNum);
          this.form.resetFields();
        } else {
          return this.$message.warning('结束时间与起始时间差必须是单位时长的整数倍');
        }
      } else {
        return this.$message.warning('起始时间需要等于上一条数据的结束时间');
      }
    }
  }
  // 提交请求发送添加

  /**
   * form布局
   */
  formItemLayout = {
    labelCol: {
      xs: { span: 8 },
      sm: { span: 8 }
    },
    wrapperCol: {
      xs: { span: 14 },
      sm: { span: 14 }
    }
  };
  tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 20,
        offset: 4
      },
      sm: {
        span: 18,
        offset: 6
      }
    }
  };
  centerFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 20,
        offset: 4
      },
      sm: {
        span: 14,
        offset: 10
      }
    }
  };
}
